import request from '@/utils/request'

export function register (data) {
  return request({
    url: '/lms/selfexams/reg',
    method: 'post',
    data
  })
}
// 获取个人信息
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=90#4311
export function getUserDetailInfo (id) {
  return request({
    url: `/selfexams/profile/${id}`,
    method: 'get'
  })
}
export function getUserInfo (id) {
  return request({
    url: `/lms/selfexams/selfInfo/${id}`,
    method: 'get'
  })
}
// 获取用户列表
export function getUserList (params) {
  return request({
    url: `/cms/user`,
    method: 'get',
    params
  })
}
// 获取个人信息
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=90#4311
export function getUserProfile (userId) {
  return request({
    url: `/selfexams/profile/${userId}`,
    method: 'get'
  })
}
// 修改用户密码
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=72#3932
export function resetUserPassword (data) {
  return request({
    url: '/user/password',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js